export enum FeatureName {
  CollapsibleMenu = 'collapsible_menu',
}
